/* =============================================================
 * import
 * ========================================================== */
import {config} from '../config.js';
import {eventObserver} from "../barba/eventObserver";


/* =============================================================
 * mwWpFormError
 * エラー項目にクラスを付与
 * ========================================================== */
export function mwWpFormError() {
  // errorクラスが付いている要素の直前にあるinput、textarea、selectにis-errorクラスを追加する
  const errorElements = document.querySelectorAll('.mw_wp_form .error');
  errorElements.forEach((errorElement) => {
    const parentElement = errorElement.closest('.form_list_cnt');
    if (parentElement) {
      parentElement.classList.add('is-error');
    }
  });
}


/* =============================================================
 * mwWpFormPrivacyCheck
 * プライバシーポリシーへの同意ボタン
 * ========================================================== */
export function mwWpFormPrivacyCheck() {
  const listeners = [];
  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]'); // 送信ボタン
  const mwWpFormPrivacy = document.querySelector('#privacy-1');

  if (mwWpFormPrivacy) {
    disabledSubmit(mwWpFormPrivacy);
    mwWpFormPrivacy.addEventListener('change', disabledSubmit);
    listeners.push([mwWpFormPrivacy, 'change', disabledSubmit]);
  }

  // プライバシーポリシーのチェックに応じてボタンをdisabled
  function disabledSubmit(event) {
    let flg;
    if (event.target === undefined) {
      flg = event.checked;
    } else {
      flg = event.target.checked;
    }

    if (flg === true) {
      mwWpFormSubmit.disabled = false;
    } else {
      mwWpFormSubmit.disabled = true;
    }
  }

  eventObserver.observeEvents(listeners);
}


/* =============================================================
 * mwWpFormReCAPTCHA
 * Google reCAPTCHAの実装（2分制限解除版）
 * ========================================================== */
export function mwWpFormReCAPTCHA() {
  const listeners = [];

  // reCAPTCHAの公開鍵が設定されていない場合、関数の実行を停止
  if (!config.recaptchaPublicKey) {
    // console.log('reCAPTCHA is disabled.');
    return; // 処理を中断
  }

  loadMwWpFormJS();
  loadReCaptcha();

  // 送信ボタンをクリックしたタイミングでreCAPTCHAを実行（2分縛りがあるため、ページ読み込み時の実行は避ける）
  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]'); // 送信ボタン
  if (mwWpFormSubmit) {
    mwWpFormSubmit.addEventListener('click', sendReCAPTCHA);
    listeners.push([mwWpFormSubmit, 'click', sendReCAPTCHA]);
  }
  eventObserver.observeEvents(listeners);
}


function sendReCAPTCHA(e) {
  const targetForm = document.querySelector('.mw_wp_form > form');   // フォーム
  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]'); // 送信ボタン

  e.preventDefault(); // フォームのデフォルト送信を防止
  mwWpFormSubmit.disabled = true; // 送信ボタンを無効にする

  grecaptcha.ready(() => {  // eslint-disable-line no-undef
    grecaptcha.execute(config.recaptchaPublicKey, {  // eslint-disable-line no-undef
      action: 'submit',
    }).then((token) => {
      // トークンをバックエンドに送信して検証（トークンと秘密鍵の照会）: https://developers.google.com/recaptcha/docs/verify#api_request
      fetch('/wp/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'action': 'verify_recaptcha', // WordPressで定義するアクションフック
          'token': token, // reCAPTCHAから取得したトークン
        }),
      })
        .then(response => response.json()) // JSON形式のレスポンスを解析
        .then(data => {
          if (data.success) {
            // 検証成功の場合、隠しフィールドを追加してフォーム送信を再試行
            const submitConfirmField = document.createElement('input');
            submitConfirmField.setAttribute('type', 'hidden');
            submitConfirmField.setAttribute('name', 'submitConfirm');
            submitConfirmField.value = '確認画面へ';
            targetForm.appendChild(submitConfirmField); // jsでsubmitするのでtype="submit"のvalueが送信できないため、hiddenフィールドで明示的に送る
            targetForm.submit(); // フォームのセレクタを適宜調整してください
          } else {
            // 検証失敗の場合、エラーメッセージを表示
            alert('reCAPTCHA verification failed. Please try again.');
            console.log('reCAPTCHA verification failed. Please try again.');
            // 送信ボタンを再度有効にする
            mwWpFormSubmit.disabled = false; // エラーが発生した場合も送信ボタンを再度有効にする
          }
        })
        .catch(error => {
          console.error('Error:', error);
          mwWpFormSubmit.disabled = false; // エラーが発生した場合も送信ボタンを再度有効にする
        });
    });
  });
}



/* =============================================================
 * loadReCaptcha
 * Google reCAPTCHAスクリプトの動的読み込み
 * ========================================================== */
function loadReCaptcha() {
  const siteKey = config.recaptchaPublicKey;

  // 既存のスクリプトタグを削除
  const existingScript = document.getElementById('recaptcha-script-js');
  if (existingScript) {
    existingScript.remove();
  }

  // 新しいスクリプトタグを作成
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
  script.id = 'recaptcha-script-js';
  document.body.appendChild(script);

  // スクリプトがロードされた後に初期化
  script.onload = function() {
    grecaptcha.ready(function() { // eslint-disable-line no-undef
      grecaptcha.execute(siteKey, { action: 'homepage' }).then(function(token) {  // eslint-disable-line no-undef
        const recaptchaResponse = document.querySelector('input[name="recaptcha-v3"]');
        if (recaptchaResponse) {
          recaptchaResponse.value = token;
        }
      });
    });
  };
}


/* =============================================================
 * loadMwWpFormJS
 * Google MW WP Form JSのスクリプトの動的読み込み
 * ========================================================== */
function loadMwWpFormJS() {

  // 既存のスクリプトタグを削除
  const existingjQuery = document.getElementById('jquery-core-js');
  if (existingjQuery) {
    existingjQuery.remove();
  }

  const existingMigrate = document.getElementById('jquery-migrate-js');
  if (existingMigrate) {
    existingMigrate.remove();
  }

  const existingScript = document.getElementById('mw-wp-form-js');
  if (existingScript) {
    existingScript.remove();
  }

  // 新しいスクリプトタグを作成
  const jQuery = document.createElement('script');
  jQuery.type = 'text/javascript';
  jQuery.src = '/wp/wp-includes/js/jquery/jquery.min.js';
  jQuery.id = 'jquery-core-js';

  jQuery.onload = function() {
    const jQueryMigrate = document.createElement('script');
    jQueryMigrate.type = 'text/javascript';
    jQueryMigrate.src = '/wp/wp-includes/js/jquery/jquery-migrate.min.js';
    jQueryMigrate.id = 'jquery-migrate-js';
    document.body.appendChild(jQueryMigrate);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/wp/wp-content/plugins/mw-wp-form/js/form.js';
    script.id = 'mw-wp-form-js';
    document.body.appendChild(script);
  };

  document.body.appendChild(jQuery);
}



/* =============================================================
 * manageBadgeReCAPTCHA
 * Google reCAPTCHAバッヂの管理
 * ========================================================== */
export function manageBadgeReCAPTCHA(data) {
  if (data.next.namespace === 'contact') { // TODO フォームを埋め込むページを指定
    document.body.classList.add('visible-recaptcha');
  } else {
    document.body.classList.remove('visible-recaptcha');
  }
}